import './init';
import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import App from './App';
import rootReducer from './reducers';
import rootSagas from './sagas';
import * as TYPES from './types';

const renderApp = (externalContainer, baseRoute, externalProps) => {
  const initialReduxState = {
    root: {},
    ...(externalProps ? externalProps.initial_redux_state : {}),
  };

  const customizedMiddleware = getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: Object.keys(TYPES),
      ignoredPaths: ['payload.onSuccess', 'payload.onError'],
    },
  });
  const sagaMiddleware = createSagaMiddleware();

  const middleware = [...customizedMiddleware, sagaMiddleware];

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line global-require
    const { logger } = require(`redux-logger`);
    middleware.push(logger);
  }

  const store = configureStore({
    preloadedState: initialReduxState,
    reducer: {
      root: rootReducer,
      Data: (state = {}) => state,
    },
    middleware,
  });
  sagaMiddleware.run(rootSagas);

  const props = {
    baseRoute,
  };

  const { sentryDSN, sentryEnv } = externalProps.props || {};
  if (sentryDSN && sentryEnv && sentryEnv !== 'localDev') {
    Sentry.init({
      dsn: sentryDSN,
      environment: sentryEnv,
      release: process.env.REACT_APP_COMMIT_ID,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      tracesSampleRate: 0.1,
      tracePropagationTargets: ['localhost', /^https:\/\/(.*\.)?tesla\.com\/api/],
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
      initialScope: { tags: { app: 'contactuswithdraw' } },
    });
  }

  ReactDOM.render(
    <Provider store={store}>
      <App {...props} />
    </Provider>,
    externalContainer
  );
};

export default renderApp;
